import { GenericModelController } from "@/controllers/model-controllers/abstract/generic-model-controller"
import { BaseRepository } from "@/repositories/base-repository"
import { type IRentalMutation } from "@/interfaces/api/rental-mutation.interface"
import { RentalMutation } from "@/models/rental-mutation.model"
import { type IStoreFunctionsConfig } from "@/store/base-functions/base-store-functions"
import { type ModelConstructorSignature } from "@/models/types/model-constructor-signature"
import { type IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"
import { Project } from "@/models/project.model"
import { HTTPQuery } from "@/builder/http-query"

export abstract class RentalMutationController<
  Model extends RentalMutation,
  IData extends IRentalMutation,
  Repository extends BaseRepository<IData>
> extends GenericModelController<Model, IData, Repository> {
  protected constructor(
    modelType: ModelConstructorSignature<IData, Model>,
    storeFunctionsConfig: IStoreFunctionsConfig<Model>,
    repository: Repository
  ) {
    super(modelType, storeFunctionsConfig, repository)
  }

  public getReturnableIssuancesListData(text: string, project?: Project): Promise<IData[]> {
    // These are custom backend query parameters, not OData filters.
    const returnableIssuancesQuery = new HTTPQuery({
      returnable: true,
      text,
      prioritize_project_id: project?.id ?? null
    })

    return this.apiFunctions.getModels({ query: returnableIssuancesQuery })
  }

  public async fakeDelete(instance: Model, requestConfig: IRepositoryRequestConfig = {}) {
    requestConfig.query = new HTTPQuery({ fake: true })
    return this.apiFunctions.deleteModel(instance, requestConfig)
  }
}
